import React from "react";

const List1 = () => {
 return (
<svg width={43} height={17} viewBox="0 0 43 17" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width={21} height={11} fill="#C9171E" />
  <rect x={22} width={21} height={11} fill="#C9171E" />
  <rect x={22} y={12} width={10} height={5} fill="#C9171E" />
  <rect y={12} width={10} height={5} fill="#C9171E" />
  <rect x={33} y={12} width={10} height={5} fill="#C9171E" />
  <rect x={11} y={12} width={10} height={5} fill="#C9171E" />
</svg>
  )
};

export default List1;